import { render, staticRenderFns } from "./SingleBlogPost.vue?vue&type=template&id=4478d6af&scoped=true&"
import script from "./SingleBlogPost.vue?vue&type=script&lang=js&"
export * from "./SingleBlogPost.vue?vue&type=script&lang=js&"
import style0 from "./SingleBlogPost.vue?vue&type=style&index=0&id=4478d6af&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4478d6af",
  null
  
)

export default component.exports